module.exports = __webpack_public_path__ + "b30487e0637687d3666e78ecd60b22b9.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/porcelain-glow/porcelain_glow_balm_packaging.jpg
 ** module id = 485
 ** module chunks = 0
 **/